import { render, staticRenderFns } from "./TwoLevelTabs.vue?vue&type=template&id=621f1411&scoped=true"
import script from "./TwoLevelTabs.vue?vue&type=script&lang=js"
export * from "./TwoLevelTabs.vue?vue&type=script&lang=js"
import style0 from "./TwoLevelTabs.vue?vue&type=style&index=0&id=621f1411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621f1411",
  null
  
)

export default component.exports